export default "__VITE_ASSET__CJJ4xXDe__"